<template >
  <v-card v-if="is_self_route" flat>
    <div>
      <div style="color: #7C7C7C;" class=" text-center py-5 mb-4" >
        По всем возникающим вопросам по заселению в Общежитие Вы можете обратиться
        в Студгородок РХТУ им. Д.И. Менделеева по контактам на официальном сайте в разделе
        <a target="_blank" href="https://www.muctr.ru/university/departments/studg/for/">Информация для заселения</a>
      </div>

      <div style="background-color: #1D71B8;" class="white--text py-4 px-6 text-left">
        После записи на заселение в общежитие, Вам необходимо в назначенное время прибыть в культурно-спортивный
        комплекс по адресу: ул. Вилиса Лациса 21.<br>
        Проезд до станции метро «Планерная», далее автобусами № 88, 96, 488, с396 до остановки «Поликлиника/Студгородок».<br>
      </div>
      <v-row no-gutters>
        <v-col cols="12" md="4">
          <div class="text-left px-4" style="font-size:12px">
            <p class="text-left pt-4 titleInfo">
              <v-icon color="primary">info</v-icon>
              ПРИ СЕБЕ ИМЕТЬ КОМПЛЕКТ ДОКУМЕНТОВ:
            </p>
            <ul style="list-style-type:square;" class="listDoc">
              <li><span>	паспорт;</span></li>
              <li><span>	копия паспорта (2-3 страницы и страницы с отметками о регистрации) 2 экз.;</span></li>
              <li><span>	4 фотографии размером 3х4 см;</span></li>
              <li><span>	копия справки  по форме № 086/у с указанием сведений о флюорографии;</span></li>
              <li><span>  копия сертификата прививок;</span></li>
            </ul>
          </div>
        </v-col>
        <v-col cols="12" md="8" class="align-center justify-center" v-show="$vuetify.breakpoint.smAndUp">
          <v-container fill-height fluid>
            <v-row align="center"
                   justify="center">
              <v-img contain :src="doc1" width="120px" height="141px"></v-img>
              <v-img contain :src="doc2" width="120px" height="141px"></v-img>
              <v-img contain :src="doc3" width="120px" height="141"></v-img>
              <v-img contain :src="doc4" width="120px" height="141"></v-img>
              <v-img contain :src="doc5" width="141px" height="141"></v-img>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </div>
    <v-card-text>
      <v-alert class="text-left" type="info" outlined>
        ОБРАЩАЕМ ВНИМАНИЕ!<br>
        Поступившие в рамках укрупненного направления подготовки (специальности) могут узнать свой факультет, перейдя по
        <a href="https://www.muctr.ru/abitur/bachelor/pk/lits/" target="_blank">ссылке</a>.
      </v-alert>
    </v-card-text>
    <v-container class="py-0 px-0" fluid v-if="!errLoad">
      <v-col cols="12" class="justify-center" style="min-height: 50vh">
        <v-data-iterator
            :items="getItems"
            :loading="isLoading"
            :page.sync="pagination.page"
            :items-per-page.sync="pagination.size"
            :server-items-length="getCount"
            hide-default-footer
        >
          <template v-slot:no-data>
            <v-container>
                <v-card-text>
                  <v-alert type="info" outlined>
                    Электронная запись на заселение в общежития начнется в августе
                  </v-alert>
                </v-card-text>
            </v-container>
          </template>
          <template v-slot:default="{ items }">
            <v-row justify="center">
              <v-col
                  v-for="item in items"
                  :key="item.id"
                  cols="12"
                  sm="6"
                  md="4"
                  lg="3"
              >
                <v-card flat class="cardBorder" height="350"
                        style=" text-overflow: ellipsis;overflow: hidden; cursor: pointer" @click="goDetail(item)">
                  <v-card-text  >
                    <div  style="height: 70px;" class="pt-4">
                      <span class="titleEvent">{{ item.name }}</span>
                    </div>
                    <div style="color: #7C7C7C;"  class=" my-0"> {{ displayDate(item.start_date) }} - {{
                        displayDate(item.end_date)
                      }}
                    </div>
                    <v-divider class="elevation-1 mt-2"></v-divider>
                  </v-card-text>

                  <v-card-text class="text-left pt-1" :title="item.description">
                    {{ item.description }}
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </template>
        </v-data-iterator>
      </v-col>
    </v-container>
    <v-container style="" v-else>
      <v-card>
        <v-card-text>
          <v-alert type="error">
            Сервис не доступен
          </v-alert>
        </v-card-text>
      </v-card>
    </v-container>
  </v-card>
  <router-view :key="$route.fullPath" style="min-height: calc(100vh - 78px)" v-else></router-view>
</template>

<script>
import names from "@/modules/recording/routers/names";
import imgCart from "@/assets/fone.jpg"
import doc1 from "@/assets/doc1.svg"
import doc2 from "@/assets/doc2.svg"
import doc3 from "@/assets/doc3.svg"
import doc4 from "@/assets/doc4.svg"
import doc5 from "@/assets/photo.svg"
import {isAuthenticated, displayDate} from "@/helper";
import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "Services",
  mixins: [
    PaginatedDataMapperMixin,
  ],
  components: {},
  computed: {
    is_self_route: function () {
      return this.$route.name === names.BASE
    },
    ...mapGetters({
      getItems: 'publicUser/getEvents',
      getCount: 'publicUser/getEventsCount',
      isLoading: 'publicUser/isLoadingEvents'
    }),
  },

  data() {
    return {
      imgCart: imgCart,
      doc1, doc2, doc3, doc4, doc5,
      errLoad: false,
    }
  },
  methods: {
    ...mapActions({
      loadList: 'publicUser/loadEventsList',
    }),
    displayDate,
    goDetail(item) {
      this.$router.push({
        name: names.PUBLIC.DETAIL,
        params: {event: item.id},

      })
    },
    loadData(url = undefined) {
      this.loadList({
        url: url,
        finalizer: (data, url) => {
          this.errLoad=false
        },
        catcher: (data, url) => {
          this.errLoad=true
        }
      })
    },

  },
  created() {
    this.loadData()
    if (isAuthenticated()) {

      let menu = []
      menu.push({
        title: 'Перечень категорий',
        icon: 'view_list',
        router: names.BASE,
      })
      menu.push({
            title: 'Мои записи',
            icon: 'view_list',
            router: names.PUBLIC.MYEVENTS,
          }
      )
      this.$store.commit('leftmenu/replaceItems', menu);
    }
  }
}
</script>

<style scoped>

.cardBorder {
  border-radius: 13px !important;
  border: 1px solid #CECECE !important;
}

.titleInfo {
  color: #1D71B8;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 24px */
}

.titleEvent {
  color: #1D71B8 !important;
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.listDoc {
  color: #404040;
  max-width: 340px;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 160.523%; /* 25.684px */
}

ul li {
  color: #1D71B8
}

ul li span {
  color: black;
}
</style>
